import React, { useEffect, useState } from 'react';
import { IoIosAddCircleOutline } from "react-icons/io";
import { MdOutlineMessage } from "react-icons/md";
import DynamicNavBar from "../../Component/navbars/navbar";
import apiRequests from "../../Component/axios/config/config";
import toast from "react-hot-toast";

export default function Reports() {
    const [reports, setReports] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedMessage, setSelectedMessage] = useState("");

    const fetchReports = () => {
        setLoading(true);
        apiRequests.get("/api/report/v1/get-all-report")
            .then((res) => {
                setReports(res.data.data);
            })
            .catch(() => {
                toast.error("خطا در دریافت گزارش‌ها");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchReports();
    }, []);

    const items = [
        { icon: <IoIosAddCircleOutline />, label: "بازنشانی", func: fetchReports },
    ];

    const openMessageModal = (message) => {
        setSelectedMessage(message);
        setShowModal(true);
    };

    return (
        <div>
            <div className="px-6 text-3xl">
                گزارش‌ها
            </div>



            <div className="flex justify-center mt-8">
                <table className="min-w-[80%]">
                    <thead className="bg-secondColor-shade4 text-white text-center">
                    <tr>
                        <th className="px-4 py-2 text-md md:text-[8px] font-medium rounded-tr-lg">پلتفرم</th>
                        <th className="px-4 py-2 text-md md:text-[8px] font-medium">نام و نام خانوادگی</th>
                        <th className="px-4 py-2 text-md md:text-[8px] font-medium">شماره</th>
                        <th className="px-4 py-2 text-md md:text-[8px] font-medium">تعداد</th>
                        <th className="px-4 py-2 text-md md:text-[8px] font-medium">پیام</th>
                        <th className="px-4 py-2 text-md md:text-[8px] font-medium">وضعیت</th>
                        <th className="px-4 py-2 text-md md:text-[8px] font-medium">ایجاد</th>
                        <th className="px-4 py-2 text-md md:text-[8px] font-medium rounded-tl-lg">ویرایش شده در</th>
                    </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                    {!loading ? (
                        reports.length > 0 ? (
                            reports.map((report, index) => (
                                <tr key={index} className="hover:bg-gray-100 md:text-[8px] text-center">
                                    <td className="px-4 py-2">{report.platform || "نامشخص"}</td>
                                    <td className="px-4 py-2">{report.full_name || "-"}</td>
                                    <td className="px-4 py-2">{report.mobile || "-"}</td>
                                    <td className="px-4 py-2">{report.count || "-"}</td>
                                    <td className="px-4 py-2">
                                        <button
                                            className="text-blue-600 hover:underline"
                                            onClick={() => openMessageModal(report.messege)}
                                        >
                                            <MdOutlineMessage size={18} className="inline-block" />
                                        </button>
                                    </td>
                                    <td className="px-4 py-2">
                                        {!report.isDeleted ? (
                                            <span className="text-green-600 font-semibold">فعال</span>
                                        ) : (
                                            <span className="text-red-600 font-semibold">غیرفعال</span>
                                        )}
                                    </td>
                                    <td className="px-4 py-2">
                                        {new Date(report.createdAt).toLocaleDateString("fa-IR")}
                                    </td>
                                    <td className="px-4 py-2">
                                        {new Date(report.updatedAt).toLocaleDateString("fa-IR")}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr className="text-center">
                                <td className="px-4 py-2" colSpan="6">گزارشی یافت نشد!</td>
                            </tr>
                        )
                    ) : (
                        <tr className="text-center">
                            <td className="px-4 py-2" colSpan="6">در حال بارگیری ...</td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>

            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
                    <div className="bg-white  rounded-lg p-6 w-1/2 h-auto text-center shadow-lg">
                        <h2 className="text-xl font-bold mb-4">متن پیام</h2>
                        <p className=" border border-blue-950 rounded-[4px] py-2 text-gray-700 mb-6 whitespace-pre-wrap">{selectedMessage || "پیامی موجود نیست"}</p>
                        <button
                            onClick={() => setShowModal(false)}
                            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                        >
                            بستن
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
